import styles from "./TransparentTile.module.scss";

interface TransparentTileProps {
  children: JSX.Element;
}

function TransparentTile(props: TransparentTileProps) {
  const { children } = props;

  return <div className={styles.transparentTileWrapper}>{children}</div>;
}

export default TransparentTile;
